import { NO_KEYWORDS_LINE, type FitView } from "@/lib/posting";
import { FitBar, FitLine, GroupLabel, KeywordChips, SectionCard } from "./parts";

/**
 * The fit: the keywords the posting names against what the resume says,
 * as a count and never a percent. At match time when envoy matched it,
 * else against the resume as it stands. A read; nothing is recorded.
 */
export default function FitCard({ fit, atMatch }: { fit: FitView | null; atMatch: boolean }) {
    return (
        <SectionCard
            className="gap-3.5"
            title="Fit"
            caption="The keywords the posting names, against what your resume says. A read; nothing is recorded."
        >
            {!fit ? (
                <p className="m-0 text-ui text-fg-muted">
                    No fit to show: there is no resume saved to score it against.
                </p>
            ) : fit.asked === 0 ? (
                <p className="m-0 text-ui text-fg-muted [text-wrap:pretty]">{NO_KEYWORDS_LINE}</p>
            ) : (
                <>
                    <div className="flex flex-col gap-2">
                        <FitLine covered={fit.covered} asked={fit.asked}>
                            {atMatch
                                ? "keywords your baseline already says, scored when it matched"
                                : "keywords your resume says as it stands"}
                        </FitLine>
                        <FitBar share={fit.share} />
                    </div>
                    {fit.listed && (
                        <div className="grid grid-cols-[repeat(auto-fit,minmax(min(240px,100%),1fr))] gap-4">
                            <div className="flex flex-col gap-2 rounded-control bg-card-raised p-3.5">
                                <GroupLabel>On your resume</GroupLabel>
                                {fit.coveredTerms.length > 0 ? (
                                    <KeywordChips terms={fit.coveredTerms} kind="covered" />
                                ) : (
                                    <span className="text-ui text-fg-muted">None.</span>
                                )}
                            </div>
                            <div className="flex flex-col gap-2 rounded-control bg-card-raised p-3.5">
                                <GroupLabel>Not on your resume</GroupLabel>
                                {fit.missing.length === 0 ? (
                                    <span className="text-ui text-fg-muted">
                                        Nothing. Your resume names every skill it does.
                                    </span>
                                ) : (
                                    <KeywordChips terms={fit.missing} kind="missing" />
                                )}
                                <span className="text-small text-fg-muted [text-wrap:pretty]">
                                    A tailor cannot add these. Decide whether they are true of you
                                    before you apply.
                                </span>
                            </div>
                        </div>
                    )}
                </>
            )}
        </SectionCard>
    );
}
